import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { apiClient } from "../../api/httpClient";

/** Shared endorsement dialog form state + county fetch for archives / approve / law-firm bonds. */
export function useBondEndorsementDialogState({ defaultStateId = 6 } = {}) {
  const userdetails = useSelector((state) => state.auth.user);
  const role = useSelector((state) => state.auth.role);

  const [endorsementDialogOpen, setEndorsementDialogOpen] = useState(false);
  const [selectedBondToEndorse, setSelectedBondToEndorse] = useState(null);
  const [endorsementType, setEndorsementType] = useState("Increase");
  const [newBondAmount, setNewBondAmount] = useState("");
  const [endorsementFile, setEndorsementFile] = useState(null);
  const [isSubmittingEndorsement, setIsSubmittingEndorsement] = useState(false);
  const [contactName, setContactName] = useState(
    `${userdetails.first_name} ${userdetails.last_name}`
  );
  const [contactEmail, setContactEmail] = useState(userdetails.email);
  const [updatedName, setUpdatedName] = useState("");
  const [counties, setCounties] = useState([]);
  const [endorsementToCounty, setEndorsementToCounty] = useState("");
  const [loadingCounties, setLoadingCounties] = useState(false);
  const [estimatedAssets, setEstimatedAssets] = useState("");
  const [dwbFirstName, setDwbFirstName] = useState("");
  const [dwbMiddleName, setDwbMiddleName] = useState("");
  const [dwbLastName, setDwbLastName] = useState("");
  const [dwbSuffix, setDwbSuffix] = useState("");
  const [dwbAlias, setDwbAlias] = useState("");
  const [endorsementPrincipalId, setEndorsementPrincipalId] = useState("");

  const bondStateId = selectedBondToEndorse?.state ?? defaultStateId;

  useEffect(() => {
    if (!endorsementDialogOpen || !bondStateId) return;
    const fetchCounties = async () => {
      setLoadingCounties(true);
      try {
        const countyResponse = await apiClient(`/counties-by-state/${bondStateId}/`, "GET");
        const formatted = (countyResponse || []).map((c) => ({
          label: c.bond_county,
          value: c.bond_county,
        }));
        setCounties(formatted);
      } catch {
        setCounties([]);
      } finally {
        setLoadingCounties(false);
      }
    };
    fetchCounties();
  }, [endorsementDialogOpen, bondStateId]);

  return {
    userdetails,
    role,
    endorsementDialogOpen,
    setEndorsementDialogOpen,
    selectedBondToEndorse,
    setSelectedBondToEndorse,
    endorsementType,
    setEndorsementType,
    newBondAmount,
    setNewBondAmount,
    endorsementFile,
    setEndorsementFile,
    isSubmittingEndorsement,
    setIsSubmittingEndorsement,
    contactName,
    setContactName,
    contactEmail,
    setContactEmail,
    updatedName,
    setUpdatedName,
    counties,
    endorsementToCounty,
    setEndorsementToCounty,
    loadingCounties,
    estimatedAssets,
    setEstimatedAssets,
    dwbFirstName,
    setDwbFirstName,
    dwbMiddleName,
    setDwbMiddleName,
    dwbLastName,
    setDwbLastName,
    dwbSuffix,
    setDwbSuffix,
    dwbAlias,
    setDwbAlias,
    endorsementPrincipalId,
    setEndorsementPrincipalId,
    bondStateId,
  };
}
